import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Modal } from "antd";

import API from "../../../config/api";
import { GET, POST } from "../../../utils/apiCalls";
import Loading from "../../../components/loading";
import NoImage from "../../../assets/images/noimage.jpg"

// Helper function to check if a time slot overlaps with investor's availability
const isTimeSlotOverlapping = (requestedSlot: string, investorTimeSlot: string) => {
  try {
    // Parse the requested slot (e.g., "10:00 AM - 10:30 AM")
    const [startTime, endTime] = requestedSlot.split(" - ");
    
    // Convert to 24-hour format for comparison
    const parseTime = (timeStr: string) => {
      const [time, period] = timeStr.split(" ");
      let [hours, minutes] = time.split(":").map(Number);
      
      if (period === "PM" && hours !== 12) {
        hours += 12;
      } else if (period === "AM" && hours === 12) {
        hours = 0;
      }
      
      return hours * 60 + minutes; // Convert to minutes for easier comparison
    };
    
    const requestedStart = parseTime(startTime);
    const requestedEnd = parseTime(endTime);
    
    // Parse investor's time slot (e.g., "10-17" or "10-12")
    const [investorStart, investorEnd] = investorTimeSlot.split("-").map(Number);
    const investorStartMinutes = investorStart * 60;
    const investorEndMinutes = investorEnd * 60;
    
    // Check if there's overlap
    // The requested slot should be completely within the investor's time slot
    return requestedStart >= investorStartMinutes && requestedEnd <= investorEndMinutes;
  } catch (error) {
    console.error("Error parsing time slots:", error);
    return false;
  }
};

function AssignModal(props: any) {
  const Events = useSelector((state: any) => state.Events);
  const User = useSelector((state: any) => state.User?.user);
  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState<any>(null);
  const [investors, setInvestors] = useState([]);

  useEffect(() => {
    loadInvestors();
  }, []);
  
  const loadInvestors = async () => {
    try {
      let url = API.INVESTORS_FREESLOT + `${Events?.defult?.id}/${props?.item}`;
      var response: any = await GET(url, null);
      if (response.status) {
        // First filter out investors already assigned to meetings in this slot
        const unassignedInvestors = response?.data?.filter(
          (investor: any) =>
            !props.slots?.some(
              (meeting: any) => meeting?.investor_id === investor?.id
            )
        );
        
        // Then filter based on time slot availability
        const availableInvestors = unassignedInvestors.filter((investor: any) => {
          return isTimeSlotOverlapping(props?.item, investor?.timeSlots);
        });
        
        setInvestors(availableInvestors);
      } else {
        setInvestors([]);
      }
      setLoading(false);
    } catch (err) {
      console.log("err", err);
      setLoading(false);
    }
  };

  const submit = async (investor: any, index: number) => {
    try {
      setLoading2(index);
      let obj = {
        slot: props?.item,
        investor_name: investor?.fullname,
        startup_name: props?.data?.data?.name,
        investor_id: investor?.id,
        startup_id: props?.data?.data?.id,
        eventId: Events?.defult?.id,
        created_by: User?.name
      };
      let response: any = await POST(API.MEETINGS_ADD, obj);
      if (response?.status) {
        props?.onChange();
        props.onClose();
      }
      setLoading2(null);
    } catch (err) {
      console.log("err", err);
      setLoading2(null);
    }
  };

  return (
    <Modal
      title={`Slot Available Investors on ${props?.item}`}
      open={props.visible}
      onCancel={() => props.onClose()}
      footer={false}
      centered
      width={600}
      height={"90vh"}
    >
      <div style={{ color: "grey" }}>{investors?.length} Corporates Available</div>
      <br />
      <div className="">
        {loading ? (
          <Loading />
        ) : investors?.length ? (
          investors?.map((item: any, index: number) => {
            return (
              <div key={item?.id} className="investorScreen-startupItem">
                <div>
                  <img src={item.logo || NoImage} className="investorScreen-startuplogo" />
                </div>
                <div style={{ flex: 1 }}>
                  <div className="investorScreen-startuptext1">
                  {item?.company}
                  </div>
                  <div className="investorScreen-startuptext2">
                  {item?.fullname} {item?.jobTitle ? `, ${item?.jobTitle}` : ""}
                  </div>
                </div>
                <div>
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => submit(item, index)}
                    loading={loading2 === index ? true : false}
                  >
                    Assign Slot
                  </Button>
                </div>
              </div>
            );
          })
        ) : (
          <div>Corporates not Available in this time slot</div>
        )}
      </div>
    </Modal>
  );
}

export default AssignModal;
